import { mapActions, mapState } from 'vuex'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import IcEncashment from '@/assets/svg/ic-encashment.svg?inline'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'EncashmentHistory',
  props: {
    amount: {
      type: Number,
      default: 0
    },
    defaultEncashmentAmount: {
      type: Number,
      default: 0
    }
  },
  components: {
    Scrollbar,
    IcEncashment,
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState({
      history: state => state.encashment.history
    })
  },
  mounted() {
    this.getEncashmentHistory()
    window.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.onClickOutside)
  },
  methods: {
    ...mapActions({
      getEncashmentHistory: 'encashment/getEncashmentHistory'
    }),

    numberWithSeparator,
    
    onClickOutside(e) {
      if (this.$refs['encashment-history'].contains(e.target)) {
        return
      }
      this.isShow = false
    }
  }
}